import { Injectable } from '@angular/core';
import { ExplanationJsonModel } from '../explanation.json.model';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';
import { AppCollection } from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class ExplanationService extends BaseCollectionService<ExplanationJsonModel, AppCollection> {
  protected ctor = ExplanationJsonModel;
}
